<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('smsSenderNameCreateModalTitle') }}</div>
    </template>
    <Spinner v-if="dataIsSending" :overlayStyle="'height: 100px'"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-0">
        <div class="p-float-label">
          <InputText id="sms-sender-modal-name"
                     :maxlength="nameMaxLength"
                     v-model="itemData.name"
                     @beforeinput="onBeforeInput"
                     @paste="onPaste"
                     @input="onInput"
                     :class="{'p-invalid' : (submitted && !itemData.name) || (itemData.name && itemData.name.length > nameMaxLength)}"
                     autocomplete="off"/>
          <label for="sms-sender-modal-name">{{ $t('Sender Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !itemData.name">{{ $t('Required field') }}</small>

        <div class="p-mt-3 p-pb-2" :class="{'warning-color': submitted && itemData.name && itemData.name.length > nameMaxLength}">
          <div>{{ $t('smsSenderNameLengthHelp', { count: nameMaxLength }) }}</div>
          <div class="p-mt-1">{{ $t('Characters left') }}: {{ computedCharsLeft }}</div>
        </div>

        <div class="p-mt-3 p-pb-3">
          <div class="p-d-flex p-ai-center medium-bold-text">
            <i class="pi pi-exclamation-triangle p-mr-1"/>
            <div>{{ $t('smsSenderNameApprovalTitle') }}</div>
          </div>
          <div class="p-mt-1">{{ $t('smsSenderNameApprovalText') }}</div>
        </div>
<!--        !!!!! DONT DELETE!!!!-->
<!--        <hr class="p-p-0">-->
<!--        <div class="">-->
<!--          <div class="p-d-flex p-ai-center">-->
<!--            <i class="pi pi-exclamation-triangle p-mr-1"></i>-->
<!--            <b>Paid feature</b>-->
<!--          </div>-->
<!--          <div class="p-mt-1">Adding a new SMS sender name is a paid feature.</div>-->
<!--          <div class="p-mt-1"><b>One-time setup fee: €15</b> per sender name.</div>-->
<!--          <div class="p-mt-1">This fee will be charged after approval.</div>-->
<!--        </div>-->
<!--        <hr class="p-p-0">-->
<!--        !!!!! DONT DELETE!!!!-->
      </div>
<!--        !!!!! DONT DELETE!!!!-->
<!--      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-2" :class="{'p-invalid' : submitted && !agreeCheckbox}">-->
<!--        <div class="agree-checkbox-block" :class="{ 'p-flex-column' : $store.state.mobileLayout }">-->
<!--          <Checkbox v-model="agreeCheckbox" :binary="true" class="p-mr-1"/>-->
<!--          <div @click="agreeCheckbox = !agreeCheckbox"-->
<!--               class="checkbox-label"-->
<!--               :class="{'p-invalid' : submitted && !agreeCheckbox}">-->
<!--            <div>I agree to the €15 one-time setup fee</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--        !!!!! DONT DELETE!!!!-->

<!--      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12" v-if="item?.id">-->
<!--        <div class="p-d-flex p-ai-center">-->
<!--          <div class="p-d-flex p-ai-center">-->
<!--            <InputSwitch id="is-active-location-modal" v-model="isActive"/>-->
<!--          </div>-->
<!--          <label for="is-active-location-modal" class="switch-label pointer">Is active</label>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" :disabled="dataIsSending" icon="pi pi-check" class="p-button-text" @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";

const ALLOWED_RE = /[A-Za-z0-9._:\- ]/g

export default {
  mixins: [ showErrorsMixins ],
  emits: ['close', 'update-items'],
  name: 'SmsSenderNameModal',
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      // agreeCheckbox: true,
      nameMaxLength: 11,
      dataIsSending: false,
      itemData: {},
      submitted: false,
      isActive: false,
      settings
    }
  },
  // mounted() {
  //   this.createPhoneCodesArray()
  // },
  watch: {
    item(value) {
      this.itemData = value ? { ...value } : {}

      // this.isActive = !value.id || !!value.status
    },
    visible() {
      if (!this.visible) {
        this.dataIsSending = false
        this.submitted = false
        this.itemData = {}
        // this.isActive = false
        // this.agreeCheckbox = false
      }
    },
  },
  methods: {
    sanitize(value) {
      // если хочешь запрещать пробелы в начале/конце — оставь trim()
      // если хочешь сохранять — замени на: const v = String(value ?? '')
      const v = String(value ?? '').trim()

      const cleaned = (v.match(ALLOWED_RE) || []).join('')
      return cleaned.slice(0, this.nameMaxLength)
    },
    onBeforeInput(e) {
      const inputType = e.inputType || ''
      const data = e.data

      if (!data || inputType.startsWith('delete') || inputType.startsWith('history')) return

      const allowed = (String(data).match(ALLOWED_RE) || []).join('')
      if (!allowed) {
        e.preventDefault()
        return
      }

      const input = e.target
      const current = this.itemData.name ?? ''
      const maxLen = this.nameMaxLength

      const start = input?.selectionStart ?? current.length
      const end = input?.selectionEnd ?? current.length

      const nextLen = current.length - (end - start) + allowed.length
      if (nextLen > maxLen) e.preventDefault()
    },

    onPaste(e) {
      e.preventDefault()

      const input = e.target
      const current = this.itemData.name ?? ''
      const text = e.clipboardData?.getData('text') ?? ''

      const start = input?.selectionStart ?? current.length
      const end = input?.selectionEnd ?? current.length

      const merged = current.slice(0, start) + text + current.slice(end)
      this.itemData.name = this.sanitize(merged)
    },

    // страховка: если beforeinput не сработал — всё равно чистим
    onInput(e) {
      const v = e?.target?.value ?? this.itemData.name
      const sanitized = this.sanitize(v)

      if (sanitized !== this.itemData.name) {
        this.itemData.name = sanitized
      }
    },
    async saveItem() {
      this.submitted = true
      if (!this.itemData.name || this.itemData.name === '' || this.itemData.name.length > this.nameMaxLength) {
        return false
      }

      this.dataIsSending = true

      const smsSenderData = {
        // id: this.itemData.id ?? null,
        name: this.itemData.name ?? null,
        // is_default: this.isDefault,
        // status: this.isActive ? 1 : 0,
        // validUntil: this.itemData.valid_until ? +new Date(this.itemData.valid_until / 1000)  : null,
      }

      // if (this.itemData.id) {
      //   try {
      //     const { status, data } = await httpClient.post(`account/create-sms-sender-name`, smsSenderData)
      //     if (status === 200 && data?.success) {
      //       this.$emit('update-items', this.itemData.id)
      //       this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
      //       this.close()
      //     } else {
      //       this.showUnknownError()
      //     }
      //   } catch(err) {
      //     this.showError(err)
      //   } finally {
      //     this.dataIsSending = false
      //   }
      // } else {
        try {
          const { status, data } = await httpClient.post(`sms-sender/create`, smsSenderData)
          if (status === 201 && data?.success) {
            this.itemData.id = data.id
            this.$emit('update-items', this.itemData.id)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
            this.close()
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
        }
      // }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedCharsLeft() {
      const charsLeft = this.itemData.name?.length ? +this.nameMaxLength - +this.itemData.name.length : this.nameMaxLength
      return charsLeft
    },
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '400px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '400px', marginTop: '25px'}
      } else {
        return {position: 'absolute', top: 0, width: '400px', marginTop: '50px'}
      }
    },
  },

}
</script>
<style scoped lang="scss">
.agree-checkbox-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .checkbox-label {
    padding: 6px 6px 6px 2px;
    margin-left: 0;
    cursor: pointer;
  }
}

</style>